// Exports
export default {
	"container": "container_XvwZc",
	"containerWithoutHeader": "containerWithoutHeader_3Z2tD",
	"containerWithoutFooter": "containerWithoutFooter_6xuFJ",
	"content": "content_S+L05",
	"contentWithMargin": "contentWithMargin_8z8v5",
	"button": "button_nNWdO",
	"errorButton": "errorButton_U4S-v",
	"errorButtonCommon": "errorButtonCommon_mbunP",
	"title": "title_dsYpg",
	"description": "description_lSSoZ",
	"wideTitle": "wideTitle_lbshV",
	"containerWithoutHeaderAndFooter": "containerWithoutHeaderAndFooter_vTY40",
	"premiumButtonHeader": "premiumButtonHeader_8Ye9N"
};
